














































import { readStructureUserDetails, readUserProfile } from '@/store/main/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { Datetime } from 'vue-datetime';
import { api } from '@/api';
import { dispatchGetStructureUserDetails, dispatchGetUserProfile } from '@/store/main/actions';
import PageSeparator from '@/components/vui-luma/Ui/PageSeparator.vue';

@Component({
  components: {
    FmvAvatar,
    Datetime,
    PageSeparator,
  },
})
export default class WorkTimesSettingsCard extends Vue {
  public formError = false;
  public loadingState = {
    submit: false,
  };
  public worktimeData: any = [
    {
      enabled: false,
      code: 'MON',
      time_from: null,
      time_to: null,
    },
    {
      enabled: false,
      code: 'TUE',
      time_from: null,
      time_to: null,
    },
    {
      enabled: false,
      code: 'WED',
      time_from: null,
      time_to: null,
    },
    {
      enabled: false,
      code: 'THU',
      time_from: null,
      time_to: null,
    },
    {
      enabled: false,
      code: 'FRI',
      time_from: null,
      time_to: null,
    },
    {
      enabled: false,
      code: 'SAT',
      time_from: null,
      time_to: null,
    },
    {
      enabled: false,
      code: 'SUN',
      time_from: null,
      time_to: null,
    },
  ];

  public async mounted() {
    this.resetForm();
  }

  public handleToggleWorktime(code) {
    const newList: any = [];
    for (const [key, value] of Object.entries(this.worktimeData)) {
      // @ts-ignore
      if (value.code === code) {
        newList.push({
          // @ts-ignore
          enabled: !value.enabled,
          // @ts-ignore
          code: value.code,
          // @ts-ignore
          time_from: value.time_from,
          // @ts-ignore
          time_to: value.time_to,
        });
      } else {
        newList.push(value);
      }
    }
    this.worktimeData = newList;
  }

  public validateForm() {
    const validatedData: any = [];
    for (const [key, value] of Object.entries(this.worktimeData)) {
      // @ts-ignore
      if (value.enabled) {
        // @ts-ignore
        if (!value.time_from || !value.time_to) {
          this.formError = true;
          // @ts-ignore
          this.showToast(this, this.$t('Please, fill empty fields'), 'error');
          return null;
        } else {
          validatedData.push({
            // @ts-ignore
            weekday: value.code,
            // @ts-ignore
            time_from: value.time_from,
            // @ts-ignore
            time_to: value.time_to,
          });
        }
      }
    }
    this.formError = false;
    return validatedData;
  }

  public resetForm() {
    if (this.userProfile && this.userProfile.work_times) {
      const newList: any = [];
      for (const [key, value] of Object.entries(this.worktimeData)) {
        // @ts-ignore
        if (this.userProfile.work_times[value.code]) {
          newList.push({
            enabled: true,
            // @ts-ignore
            code: this.userProfile.work_times[value.code].code,
            // @ts-ignore
            time_from: this.userProfile.work_times[value.code].time_from,
            // @ts-ignore
            time_to: this.userProfile.work_times[value.code].time_to,
          });
        } else {
          newList.push(value);
        }
      }
      this.worktimeData = newList;
    }
    this.$emit('close-modal');
  }

  public async handleSubmit() {
    const validateData = await this.validateForm();
    if (!this.formError) {
      this.loadingState.submit = true;
      try {
        const response = await api.updateUserWorkTimes(
          this.$store.getters.token, validateData,
        );
        await dispatchGetUserProfile(this.$store);
        // @ts-ignore
        this.showToast(this, this.$t('Changes saved'));
        this.resetForm();
      } catch (e) {
        // @ts-ignore
        if (e.response.data && e.response.data[0].time_from) {
          // @ts-ignore
          this.showToast(this, this.$t('Incorrect time from and time to'), 'error');
        } else {
          // @ts-ignore
          this.showToast(this, this.$t('Error'), 'error');
        }
      }
      this.loadingState.submit = false;
    }
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  get available() {
    const groups = [
      'Менеджеры - Консультирование', 'Менеджеры - Партнерство',
      'Руководители - Консультирование', 'Руководители - Партнерство',
      'Руководитель отдела консультантов', 'Админы',
      "Руководитель отдела консультирования",
      "Руководитель партнерского отдела",
      "Менеджер отдела консультирования",
      "Менеджер партнерского отдела",
      "Администратор отдела консультирования",
      "Администратор партнерского отдела",
      "Консультант отдела консультирования",
      "Консультант партнерского отдела",
    ];
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      for (const [key, value] of Object.entries(groups)) {
        // @ts-ignore
        if (userProfile.groups.includes(value)) {
          return true;
        }
      }
    }
    return false;
  }

}
